import Header from "../components/Header";
import Footer from "../components/Footer";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function Home() {
    return (
        <body>
            <Header />
            <main>
                <h1>hej med dig! :D</h1>
                <DogImageNav>
                    <Link to="/bessi">
                        <img
                            src="https://cdn.discordapp.com/attachments/845693852299952159/1238995380205781052/Untitled_Artwork.png?ex=6642a15e&is=66414fde&hm=0083049454b41c8518448ca137b921ffb3adced7a38781bcba0d792df647c12d&"
                            alt="Bessi"
                            title="gå til Bessi"
                        />
                    </Link>
                    <Link to="/vinur">
                        <img
                            src="https://cdn.discordapp.com/attachments/845693852299952159/1239002694446878780/Vinur1.png?ex=6642a82d&is=664156ad&hm=f9a9e2f8ebe1b1e7012d07c14ea6e1c8f3e12effc5737d13740fc26bdf0b1ca7&"
                            alt="Vinur"
                            title="gå til Vinur"
                        />
                    </Link>
                    <Link to="/skuli">
                        <img
                            src="https://cdn.discordapp.com/attachments/845693852299952159/1239012043667935253/Skuli.png?ex=6642b0e2&is=66415f62&hm=c2126a7f3d5015a95fd2ab4f944e51ffbe5d69599ede7bc95bb241af2f5356a0&"
                            alt="Skúli"
                            title="gå til Skúli"
                        />
                    </Link>
                    <Link to="/fylkir">
                        <img
                            src="https://cdn.discordapp.com/attachments/845693852299952159/1239019315479576696/Fylkir.png?ex=66420ee8&is=6640bd68&hm=7bbb15d8768a12591707b27d9bd1d472a1dfca60f1d05e8da0e0205dc226891e&"
                            alt="Fylkir"
                            title="gå til Fylkir"
                        />
                    </Link>
                </DogImageNav>
            </main>
            <Footer />
        </body>
    );
}

const DogImageNav = styled.div`
    margin: 2rem auto;
    display: grid;
    grid-template-columns: repeat(2, 180px);
    gap: 1rem;
    height: 360px;
    width: 360px;
    img {
        width: 100%;
    }
`;
